import { Group } from "./Group";
import { Outlined } from "./Outlined";
import { Filled } from "./Filled";

export const ComponentContainer = { Group, outlined: Outlined, filled: Filled };
